import { customElement } from 'lit/decorators.js';

import JobSchema from '../../../../../models/job-schema.js';

import NSBankFormJob, { BankFormCopy } from './bank-form-job.js';
import definition from '@job-schemas/company/bank/verify.json';
import { jobSchema } from '../../../job-schema.js';

interface FormValues {
  reference: string;
}

@customElement(NSCompanyBankVerify.is)
export default class NSCompanyBankVerify extends NSBankFormJob<FormValues> {
  static get is() {
    return 'ns-company-bank-verify';
  }

  static get schema(): JobSchema {
    return jobSchema(definition, { outcomes: { complete: { type: 'hidden' } } });
  }

  protected get _copy(): BankFormCopy<FormValues> {
    return {
      intro:
        'nodeStream has made a low-value transfer to your bank account with a unique reference. Check your bank statement and enter that reference below to confirm you control this account.',
      heading: 'Enter the reference that we sent alongside the bank transfer made by nodeStream',
      fields: [{ name: 'reference', label: 'Reference', requiredMessage: 'Please enter the bank transfer reference' }],
      lambda: 'bank/verify-transfer-reference',
      loadingMessage: 'Verifying the transfer reference',
      info: [
        {
          label: 'Where to find the reference',
          text: "Look for a small payment from nodeStream on your company's bank statement. The reference is shown next to it, for example in the payment's description.",
        },
        {
          label: 'Entering it',
          text: "Enter the reference exactly as it appears, including capital letters and spaces. If it doesn't match, check it against your statement and try again.",
        },
        {
          label: 'What happens next',
          text: "Once it matches, your company's bank account is marked as verified.",
        },
      ],
    };
  }

  protected _requestBody(values: Partial<FormValues>) {
    return { reference: values.reference };
  }
}
